export default "__VITE_ASSET__BGto7uc6__"